﻿import React from 'react';

import { EIntegration } from 'pages/partners/components/IntegrationsTab/constants';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { FormattedMessage, useIntl } from 'react-intl';
import { IntegrationVendor } from 'apis/PartnerApi';
import { Col, Row } from 'react-bootstrap';

type BulbIntegrationProps = {
    copyClipboardWithMessage: (copyText: string) => void;
    generateLTIKeyAndSecret: (integrationType: EIntegration) => void;
    integration: IntegrationVendor;
}

export const BulbIntegration = ({ copyClipboardWithMessage, generateLTIKeyAndSecret, integration }: BulbIntegrationProps) => {

    const { formatMessage } = useIntl();

    return (
        <>
            <h5 className="my-3 integrations__title">
                bulb
                <FormattedMessage defaultMessage="Integration" id="integration.d25f52d8" />
            </h5>
            <Row>
                <Col className="col-12 col-lg-4">
                    <Row>
                        <Col className="col-8">
                            <GMetrixInput
                                readOnlyNoLock
                                label={formatMessage({ id: 'consumer_key.0bfc65df', defaultMessage: 'Consumer Key' })}
                                value={integration.Key}
                            />
                        </Col>
                        <Col className="d-flex align-items-end col-4">
                            <GMetrixButton onClick={() => integration.Key && copyClipboardWithMessage(integration.Key)} variant='primary'>
                                <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                            </GMetrixButton>
                        </Col>
                    </Row>
                </Col>
                <Col className="col-12 col-lg-4">
                    <Row>
                        <Col className="col-8">
                            <GMetrixInput
                                readOnlyNoLock
                                label={formatMessage({ id: 'secret.f941d41a', defaultMessage: 'Secret' })}
                                value={integration.Secret}
                            />
                        </Col>
                        <Col className="d-flex align-items-end col-4">
                            <GMetrixButton onClick={() => integration.Secret && copyClipboardWithMessage(integration.Secret)} variant='primary'>
                                <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                            </GMetrixButton>
                        </Col>
                    </Row>
                </Col>
                <Col className="col-12 col-lg-4">
                    <Row>
                        <Col className="col-8">
                            <GMetrixInput
                                readOnlyNoLock
                                label={formatMessage({ id: 'redirect_url.90668e3b', defaultMessage: 'Redirect URL' })}
                                value={integration.RedirectUrl}
                            />
                        </Col>
                        <Col className="d-flex align-items-end col-4">
                            <GMetrixButton onClick={() => integration.RedirectUrl && copyClipboardWithMessage(integration.RedirectUrl)} variant='primary'>
                                <FormattedMessage defaultMessage="Copy" id="copy.fa37e351" />
                            </GMetrixButton>
                        </Col>
                    </Row>
                </Col>
                {integration.Key.length === 0 && integration.Secret.length === 0 && (
                <Col className="mt-3" md={12}>
                    <GMetrixButton onClick={() => generateLTIKeyAndSecret(EIntegration.Bulb)} variant="primary">
                        <FormattedMessage defaultMessage="Generate" id="generate.bfb10aed" />
                    </GMetrixButton>
                </Col>
                )}
            </Row>
            <hr />
        </>
    );

};